var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(-929 -4076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z",
    transform: "translate(929 4076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(942 4089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M6.94,5a2,2,0,1,1-2-2,2,2,0,0,1,2,2ZM7,8.48H3V21H7Zm6.32,0H9.34V21h3.94V14.43c0-3.66,4.77-4,4.77,0V21H22V13.07c0-6.17-7.06-5.94-8.72-2.91Z",
    fill: "#1d53ba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6816acd744e4bf3c27ff6a07c59330f7.svg";
export { ForwardRef as ReactComponent };